export default __webpack_public_path__ + "static/media/scrum-study-cards-deck.55805d54.png";